import { ISbBidAdjustmentItem, ISbPlacementResult } from "../../types/sbPlacementApi.types"

export enum SponsoredBrandsPlacementsActionType {
  FETCH_SPONSORED_BRANDS_PLACEMENTS = "FETCH_SPONSORED_BRANDS_PLACEMENTS",
  FETCH_SPONSORED_BRANDS_PLACEMENTS_SUCCESS = "FETCH_SPONSORED_BRANDS_PLACEMENTS_SUCCESS",
  FETCH_SPONSORED_BRANDS_PLACEMENTS_ERROR = "FETCH_SPONSORED_BRANDS_PLACEMENTS_ERROR",
  RESET_SPONSORED_BRANDS_PLACEMENTS = "RESET_SPONSORED_BRANDS_PLACEMENTS",
  SET_SB_PLACEMENT_ADJUSTMENT = "SET_SB_PLACEMENT_ADJUSTMENT",
  CLEAR_SB_PLACEMENT_ADJUSTMENTS = "CLEAR_SB_PLACEMENT_ADJUSTMENTS",
  APPLY_SB_AUDIENCE_TO_CAMPAIGNS = "APPLY_SB_AUDIENCE_TO_CAMPAIGNS",
}

interface FetchSponsoredBrandsPlacements {
  type: SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS
}

interface FetchSponsoredBrandsPlacementsSuccess {
  type: SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS_SUCCESS
  payload: ISbPlacementResult[]
}

interface FetchSponsoredBrandsPlacementsError {
  type: SponsoredBrandsPlacementsActionType.FETCH_SPONSORED_BRANDS_PLACEMENTS_ERROR
  payload: string
}

interface ResetSponsoredBrandsPlacements {
  type: SponsoredBrandsPlacementsActionType.RESET_SPONSORED_BRANDS_PLACEMENTS
}

interface SetSbPlacementAdjustment {
  type: SponsoredBrandsPlacementsActionType.SET_SB_PLACEMENT_ADJUSTMENT
  payload: { campaignId: string; adjustment: ISbBidAdjustmentItem | null }
}

interface ClearSbPlacementAdjustments {
  type: SponsoredBrandsPlacementsActionType.CLEAR_SB_PLACEMENT_ADJUSTMENTS
}

interface ApplySbAudienceToCampaigns {
  type: SponsoredBrandsPlacementsActionType.APPLY_SB_AUDIENCE_TO_CAMPAIGNS
  payload: { campaignIds: string[]; audienceId: string }
}

export type SponsoredBrandsPlacementsAction =
  | FetchSponsoredBrandsPlacements
  | FetchSponsoredBrandsPlacementsSuccess
  | FetchSponsoredBrandsPlacementsError
  | ResetSponsoredBrandsPlacements
  | SetSbPlacementAdjustment
  | ClearSbPlacementAdjustments
  | ApplySbAudienceToCampaigns

export interface SponsoredBrandsPlacementsState {
  placementData: ISbPlacementResult[]
  pendingAdjustments: Record<string, ISbBidAdjustmentItem>
  loading: boolean
  error: null | string
}
